window.jQuery = require('jquery');
window.$ = window.jQuery;
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/widgets/sortable');
require('jquery-ui/ui/widgets/slider');
require('jquery-ui/ui/widgets/spinner');
require('./datepicker-ja');
require('./jquery.flexslider');
require('./jquery.niftymodals');
require('./slick.min');
require('./jquery.sticky');
require('./loading');
require('./message');




// WEBPACK FOOTER //
// ./app/javascript/plugins/index.js